export default {
  meta: {
    title: "Basetao Spreadsheet: Produkte, Bewertungen & Versand-Guide",
    description: "Unabhängige Informationsquelle zu Basetao Spreadsheet — Produkte finden, Verkäufer vergleichen, QC-Fotos prüfen, Versandkosten und Seriosität von Basetao.",
  },
  brand: "Basetao Sheet",
  nav: {
    home: "Startseite",
    categories: "Kategorien",
    shoppingGuide: "Einkaufsratgeber",
    readGuide: "Leitfaden lesen",
    safety: "Sicherheit",
  },
  button: {
    buyNow: "Jetzt kaufen",
    basetaoSpreadsheet: "Basetao Spreadsheet",
    readGuide: "Leitfaden lesen",
    readArticle: "Ganzen Artikel lesen",
    exploreCategories: "Kategorien entdecken",
    backHome: "Zurück zur Startseite",
    visitMain: "Hauptwebsite besuchen",
    viewAll: "Alle ansehen",
  },
  cat: {
    shoes: "Schuhe",
    hoodies: "Hoodies / Sweater",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen / Shorts",
    headwear: "Kopfbedeckungen",
    sets: "Sets",
    underwear: "Unterwäsche / Unterhosen",
    jersey: "Trikots",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfums",
    other: "Sonstiges",
  },
  notFound: {
    title: "Seite nicht gefunden",
    desc: "Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.",
  },
  footer: {
    tagline: "Unabhängige Informationsquelle über Basetao Spreadsheet.",
    quickLinks: "Schnellzugriff",
    categories: "Kategorien",
    disclaimer: "Basetao Sheet ist eine unabhängige Informationsquelle und nicht offiziell mit Basetao verbunden. Informationen können sich ändern und sollten vor einem Kauf oder einer Zahlung überprüft werden.",
    allRights: "Alle Rechte vorbehalten.",
  },
  articleMeta: {
    shortAnswerLabel: "Kurzantwort",
    tocTitle: "Inhaltsverzeichnis",
    checklistTitle: "Wichtige Punkte zum Prüfen",
    faqTitle: "Häufig gestellte Fragen",
    conclusionTitle: "Das Fazit",
    authorLabel: "Autor",
    author: "Basetao Sheet Redaktionsteam",
    publishedLabel: "Veröffentlicht",
    published: "2026",
    updatedLabel: "Aktualisiert",
    updated: "August 2026",
    disclaimer:
      "Basetao Sheet ist eine unabhängige Informationsquelle und nicht offiziell mit Basetao verbunden. Informationen können sich ändern und sollten vor einem Kauf oder einer Zahlung überprüft werden.",
  },
};